<button
  className="{{ sizeClassNames }} {{ themeClassNames }} {{
    classNames
  }} cursor-pointer
inline-flex items-center justify-center flex-shrink-0 hover:opacity-75"
  type="button">
  <ng-content></ng-content>
</button>
